import React from 'react';
import { formatDisplayId } from '@/utils/formatters/displayIdFomatter';

interface LabNumberProps {
    labNumber: number;
}

export default function LabNumber({ labNumber }: LabNumberProps) {
    return (
        <div className="flex font-cantarell font-bold text-color-id text-xs">
            Lab No.
            {formatDisplayId(labNumber, 12)}
        </div>
    );
}
